module.exports = __webpack_public_path__ + "img/Income Type.097fd127.png";